import { Photo } from './Photo';
import { registerSchema } from './transform';

export class CommunityInfo {
  MembersTotal: number = 0;
  MembersOnline: number = 0;
  MerchandiseUrl: string | null = null;
  FacebookUrl: string | null = null;
  InstagramUrl: string | null = null;
  TwitterUrl: string | null = null;
}

export class MemberAccount {
  // MemberBasic properties (inherited in backend)
  Id: number = 0;
  UserName: string = '';
  FirstName: string | null = null;
  IconUrl: string = '';
  PlaceName: string | null = null;
  HasProfilePhoto: boolean = false;

  // MemberAccount specific properties
  PublicPhotosCount: number = 0;
  PrivatePhotosCount: number = 0;
  FollowingCount: number = 0;
  FollowersCount: number = 0;
  UnlockedCount: number = 0;
  BlockedCount: number = 0;
  PlanName: string = '';
  IsPremium: boolean = false;
  PremiumEndsOn: Date | null = null;
  PublicPhotos: Photo[] | null = null;
  PrivatePhotos: Photo[] | null = null;
  CommunityInfo: CommunityInfo = new CommunityInfo();
} 

registerSchema(MemberAccount, {
  PremiumEndsOn: 'date',
  PublicPhotos: [Photo],
  PrivatePhotos: [Photo],
  CommunityInfo: CommunityInfo,
});